import { graphql } from '@/gql';

/**
 * Per-stage door insights for one night. The same document backs the
 * panel's query and the `liveUpdated.entranceInsights` cache write, so the
 * live payload replaces the cached result wholesale.
 */
export const NightEntranceInsightsDoc = graphql(/* GraphQL */ `
  query NightEntranceInsights($nightId: UUID!) {
    nightEntranceInsights(nightId: $nightId) {
      nightId
      nightTitle
      rows {
        stageId
        label
        sold
        scanned
        admitted
        refused
      }
      total {
        stageId
        label
        sold
        scanned
        admitted
        refused
      }
    }
  }
`);
